import React, { useState } from "react";
import "./ProgressTracker.css";

const ProgressTracker = ({ currentStep }) => {
  const steps = ["My Cart", "Address", "Payment", "Done"];

  const getClassForStep = (stepIndex) => {
    if (stepIndex < currentStep) {
      return "completed";
    } else if (stepIndex === currentStep) {
      return "current";
    } else {
      return "";
    }
  };

  return (
    <div className="progresstracker_section pt-40 pb-40">
      <div className="container">
        <div className="row">
          <div className="col-12 d-flex" style={{ justifyContent: "center" }}>
            <ol className="progress-tracker">
              {steps.map((step, index) => (
                <li
                  key={index}
                  className={getClassForStep(index + 1)} // Pass step index as 1-indexed
                >
                  <span>{step}</span>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressTracker;
